import { computed } from 'vue';
import { useDateFormat, useNow } from '@vueuse/core';

export function useCcfp(selectedPrice) {
  // TODO: can be refactored to utility function
  const departmentId = computed(() => selectedPrice?.value?.departmentData.departmentId);
  const ccfpObject = computed(() => selectedPrice?.value?.ccfpData);
  const selectedChargePlans = computed(() => {
    const details = ccfpObject?.value?.chargePlanPDPDeptDetails;
    return details && details[departmentId.value];
  });

  const priceAndFormattedValue = computed(() => {
    const { value: price, formattedValue } = selectedPrice?.value?.lowestSalePriceTier?.values?.[0] || {};
    return { price, formattedValue };
  });
  const formattedValue = computed(() => priceAndFormattedValue.value?.formattedValue);

  const deptDetails = computed(() => {
    const priceAndFormattedValueData = priceAndFormattedValue.value;
    const chargePlans = selectedChargePlans?.value;

    if (!priceAndFormattedValueData || !chargePlans) {
      return [];
    }

    return chargePlans
      .filter((planDetail) => planDetail)
      .map((planDetail) => ({
        ...planDetail,
        pricePerMonth: Math.ceil(priceAndFormattedValueData.price / planDetail.ticketTermCode),
      }));
  });
  const qualifiedPlanDetails = computed(() => deptDetails.value.filter((plan) => plan.minimumPurchase <= priceAndFormattedValue.value.price));
  const minimumPurchase = computed(() => {
    const sortedDeptDetails = [...deptDetails.value].sort((a, b) => a.minimumPurchase - b.minimumPurchase);
    return sortedDeptDetails.length > 0 ? sortedDeptDetails[0].minimumPurchase : 0;
  });
  const addOn = computed(() => Math.ceil(minimumPurchase.value - priceAndFormattedValue.value.price));
  const seatEligible = computed(() => !!(qualifiedPlanDetails.value.length > 0));

  const formatted = useDateFormat(useNow(), 'MM/DD/YYYY');
  const messageAPR = computed(() => ccfpObject.value?.messageAPR?.replace(/__DATE__/g, formatted.value));

  const isSingleSeat = computed(() => qualifiedPlanDetails.value?.length === 1);
  const targetPlan = computed(() => (seatEligible.value ? qualifiedPlanDetails?.value[qualifiedPlanDetails?.value?.length - 1]
    : deptDetails?.value[0]));
  const isCcfp = deptDetails.value.length > 0;

  return {
    addOn,
    deptDetails,
    qualifiedPlanDetails,
    seatEligible,
    isSingleSeat,
    targetPlan,
    formattedValue,
    messageAPR,
    minimumPurchase,
    isCcfp,
  };
}

export default useCcfp;
